/**
 * @ngdoc directive
 * @name usersHeader
 * @module flowingly.runner.setup
 * @description This component is used to display the header for the users and will contain controls
 * @usage
 * ```
      <users-header></users-header>
 * ``` 
 * NOTE: Minimal content for now, but this might grow
 */
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';

angular.module('flowingly.runner.setup').component('usersHeader', {
  template: `
    <button 
      ng-disabled="!$ctrl.canInviteUsers" 
      ng-attr-title="{{$ctrl.inviteUsersTooltip}}" 
      ng-hide="$ctrl.hideInviteUsers" 
      ng-click="$ctrl.onImportUsersClick()" 
      class="btn btn-primary mt-25 mr-10 btn-primary--blue">
      Bulk Invite
    </button>
    <button 
      ng-disabled="!$ctrl.canInviteUsers" 
      ng-attr-title="{{$ctrl.inviteUsersTooltip}}" 
      ng-hide="$ctrl.hideInviteUsers" 
      ng-click="$ctrl.onAddUsersClick()" 
      class="btn btn-primary mt-25">
      Invite Users
    </button>
  `,
  controller: [
    '$scope',
    'dialogService',
    'intercomService',
    'APP_CONFIG',
    'permissionsService',
    function (
      $scope,
      dialogService,
      intercomService,
      APP_CONFIG,
      permissionsService
    ) {
      const $ctrl = this;

      $ctrl.onAddUsersClick = onAddUsersClick;
      $ctrl.onImportUsersClick = onImportUsersClick;
      $ctrl.hideInviteUsers = false;
      $ctrl.canInviteUsers = permissionsService.currentUserHasPermission(
        FlowinglyPermissions.USER_CREATE
      );
      $ctrl.inviteUsersTooltip = $ctrl.canInviteUsers
        ? ''
        : 'You do not have the Setup - Users - Invite permission';
      $scope.$watch(
        function () {
          return APP_CONFIG.hideInviteUsers;
        },
        function () {
          $ctrl.hideInviteUsers = APP_CONFIG.hideInviteUsers;
        },
        true
      );

      function onAddUsersClick() {
        if (!$ctrl.canInviteUsers) {
          return;
        }
        dialogService
          .showDialog({
            template:
              'Client/runner.setup/runner.setup.users/add.users/runner.setup.users.add.tmpl.html',
            controller: 'userAddController',
            appendClassName: 'ngdialog-normal',
            scope: $scope,
            data: null
          })
          .then(function (result) {
            if (dialogService.isCloseModalWithCancelAction(result)) {
              //user closed modal by clicking on overlay (or cancel or press Esc key)
              return;
            }
            if (result) {
              intercomService.trackEvent('Added Users');
            }
          });
      }

      function onImportUsersClick() {
        if (!$ctrl.canInviteUsers) {
          return;
        }
        dialogService
          .showDialog({
            template: 'Client/runner.import/runner.import.dialog.tmpl.html',
            controller: 'runnerImportDialogController',
            appendClassName: 'ngdialog-normal',
            scope: $scope,
            data: {
              modalTitle: 'Invite Users',
              instructionText:
                'Open the file in your favorite spreadsheet editor. Enter first name, last name & email for each user you wish to invite.',
              actionText: 'Invite Users',
              templateUrl: ASSETS_PATH + '/bulk_import_users.csv'
            }
          })
          .then(function (result) {
            if (dialogService.isCloseModalWithCancelAction(result)) {
              //user closed modal by clicking on overlay (or cancel or press Esc key)
              return;
            }
          });
      }
    }
  ]
});
